import React from 'react'
import { useNavigate } from "react-router-dom";

function ViewPatientLabReports() {
    const navigate = useNavigate();
    return (
        <>
            <main className='bg-white' style={{ width: "100%" }}>
                <div className="row p-3">
                    <div className="col-12">
                        <div className='p-2 d-flex align-items-center justify-content-between'>
                            <h4 className=''>Patient Reports</h4>
                        </div>
                    </div>

                    <div className="co-12 mb-2">
                        <div className="ps-2">
                            <div className="card border-0 p-3" style={{ boxShadow: "rgba(99,99,99,.2) 0px 2px 8px 0px " }}>
                                <div className="d-flex align-items-center justify-content-between mt-2 p-3">
                                    <span style={{ color: "#636D73", fontSize: "14px" }}>Assigned Doctor <span style={{ color: "#2662F0" }}>Dr. Rohan</span></span>
                                  
                                </div>
                                <span className='mt-2 mb-1 p-3'>PATIENT DETAILS</span>

                                <div className="d-flex mb-3 flex-wrap p-3" style={{ width: "100%" }}>
                                    <div className='d-flex flex-column div-kscakmxak' style={{ width: "50%" }}>
                                        <div className="mt-3 d-flex align-items-start">
                                            <span style={{ fontWeight: "600", width: "50%" }}>Patient Name</span>
                                            <span style={{ width: "50%" }}>ALEX KEV</span>
                                        </div>

                                        <div className="mt-3 d-flex align-items-start">
                                            <span style={{ fontWeight: "600", width: "50%" }}>Patient - ID</span>
                                            <span style={{ width: "50%" }}>#P-00012 </span>
                                        </div>

                                        <div className="mt-3 d-flex align-items-start">
                                            <span style={{ fontWeight: "600", width: "50%" }}>Gender</span>
                                            <span style={{ width: "50%" }}>Male</span>

                                        </div>

                                        <div className="mt-3 d-flex align-items-start">
                                            <span style={{ fontWeight: "600", width: "50%" }}>Age</span>
                                            <span style={{ width: "50%" }}>58 </span>
                                        </div>
                                    </div>

                                    <div className='d-flex flex-column div-kscakmxak' style={{ width: "50%" }}>
                                        <div className="mt-3 d-flex align-items-start">
                                            <span style={{ fontWeight: "600", width: "50%" }}>Blood Group</span>
                                            <span style={{ width: "50%" }}>o +ve</span>
                                        </div>

                                        <div className="mt-3 d-flex align-items-start">
                                            <span style={{ fontWeight: "600", width: "50%" }}>Blood Pressure</span>
                                            <span style={{ width: "50%" }}>130/80 mm </span>
                                        </div>

                                        <div className="mt-3 d-flex align-items-start">
                                            <span style={{ fontWeight: "600", width: "50%" }}>Contact Number</span>
                                            <span style={{ width: "50%" }}>+1  5765 785 689</span>

                                        </div>
                                    </div>
                                </div>

                                <span className='mt-2 mb-3 p-3'>PATIENT REPORT</span>

                                <div className="row p-3">
                                    <div className="col-12 col-md-8 mb-3">
                                        <div className="border rounded-1 p-2">
                                            <h6 className='fw-semibold mb-3 mt-2' style={{ borderBottom: "solid 1px #000", maxWidth: "15rem" }}>SARS COV - 2 REAL TIME PCR</h6>

                                            <div className="d-flex align-items-center gap-5 mb-2">
                                                <span>SARS - COV - 2 RNA</span>
                                                <span className='fw-semibold'>POSITIVE</span>
                                            </div>

                                            <p className='abt-proof'><span className='fw-semibold'>Objective :</span> To analyse the frequency of adverse events to treatment reported by patients
                                                in relation to consultation time, attention from their usual doctor and information
                                                provided by their doctor about treatment.
                                            </p>

                                            <p className='abt-proof'><span className='fw-semibold'>Design  :</span> Descriptive study.
                                                Patients were invited to respond to a telephone survey.
                                            </p>

                                            <p className='abt-proof'><span className='fw-semibold'>Results   :</span> 1557 (17.6%, CI 95% 16.8 to 18.4%)
                                                of the adults and 867 (13.7%, 95% CI 12.8 to 14.5%) of the children reported adverse or
                                                unexpected reactions to the treatment according to patients' reports. Consultation time
                                                (OR 0.5, 95% CI 0.4 to 0.5), doctor rotation at the health centre
                                                (OR 2.04, 95% CI 1.85 to 2.25) and information on treatment precautions
                                                (OR 0.47, 95% CI 0.43 to 0.53) determine the higher risk of adverse reactions to treatment.
                                            </p>

                                            <p className='abt-proof'><span className='fw-semibold'>Conclusions :</span> Planning at
                                                health centres should involve the monitoring of mean consultation time and doctor rotation
                                                as indirect indicators of safety. Furthermore, protocols related to the information
                                                provided to patients should be reviewed.
                                            </p>

                                            <div className=' d-flex flex-column text-center mb-3'>
                                                <span className='fw-semibold'>End of Report</span>
                                                <span className='fw-semibold'>Please visit www.sirworld for related test information for this accession</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="col-12 col-md-4 mb-3">
                                        <span className='fw-semibold' style={{}}>View Documents Provided</span>
                                        <div className="border rounded-1 p-2 mt-2 mb-3">
                                            <div className="d-flex align-items-center justify-content-between p-2 mb-2" style={{ background: '#F7F7F7' }}>
                                                <span>1.pdf</span>
                                                <img src="/Images/teenyicons_pdf-solid.svg" alt="" />
                                            </div>

                                            <div className="d-flex align-items-center justify-content-between p-2 mb-2" style={{ background: '#F7F7F7' }}>
                                                <span>2.pdf</span>
                                                <img src="/Images/teenyicons_pdf-solid.svg" alt="" />
                                            </div>

                                            <div className="d-flex align-items-center justify-content-between p-2 mb-2" style={{ background: '#F7F7F7' }}>
                                                <span>3.pdf</span>
                                                <img src="/Images/teenyicons_pdf-solid.svg" alt="" />
                                            </div>
                                        </div>

                                        <span className='fw-semibold' style={{}}>Physician’s  Notes</span>

                                        <div className="border rounded-1 p-2 mt-2">

                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className='p-2 text-end'>
                                            <button className='border rounded-5' style={{ padding: '.4rem 2rem', background: '#028391', color: "#fff" }} onClick={() => navigate("/PatientLabReports")}>Back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default ViewPatientLabReports